import { Base } from '@studiometa/js-toolkit';
import Swiper from 'swiper';

/**
 * Slider component
 */
export default class ProductCard extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'ProductCard',
    refs: ['thumbItems[]', 'slider', 'sliderText'],
  };

  /**
   *
   */
  mounted() {
    this.slider = new Swiper(this.$refs.slider, {
      spaceBetween: 0,
      slidesPerView: 1,
      allowTouchMove: false,
    });

    this.sliderText = new Swiper(this.$refs.sliderText, {
      spaceBetween: 0,
      slidesPerView: 1,
      allowTouchMove: false,
    });

    this.updateActiveThumb(0);
  }

  /**
   * Click on thumbs to change sliders
   * @param {object} props
   * @param {Event} props.event
   * @param {number} props.index
   */
  onThumbItemsClick({ event, index }) {
    event.preventDefault();
    this.slider.slideTo(index);
    this.sliderText.slideTo(index);
    this.updateActiveThumb(index);
  }

  /**
   * Active thumbs when clicked
   * @param {number} index
   */
  updateActiveThumb(index) {
    this.$refs.thumbItems.forEach((item, i) => {
      item.classList.toggle('is-active', i === index);
    });
  }
}
